import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './compontents/Home/HomePage/HomePage';
import AboutUsPage from './compontents/AboutUs/AboutUsPage/AboutUsPage';
import Menu from './compontents/Menu/Menu';
import Navbar from './compontents/Navbar/Navbar';
import { useState } from 'react';
import SignUp from './compontents/SignUp/SignUp';
import Cart from './compontents/Cart/Cart';
import PlaceOrder from './compontents/PlaceOrder/PlaceOrder';
import Footer from './compontents/Footer/Footer';
import AddOn from './compontents/AddOn/AddOn';
import StoreContextProvider from './compontents/context/StoreContext';
import RecommendationProvider from './compontents/context/RecommendationContext';
import PaymentMethod from './compontents/PaymentMethod/PaymentMethod';
import MyOrders from './compontents/MyOrders/MyOrders';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [showLogin, setShowLogin] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [showPayment, setShowPayment] = useState(false);

  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedButtons, setSelectedButtons] = useState([]);

  const [category,setCategory] = useState("All");

  const addToCart = (item) => {
    setSelectedItems(prevItems => [...prevItems, item]);
  };

  const handleButtonClick = (buttonNumber) => {
    setSelectedButtons(prevButtons => [...prevButtons, buttonNumber]);
  };

  return (
    <>
      <BrowserRouter basename='/'>
        <StoreContextProvider>
        <RecommendationProvider>
          <ToastContainer />
        {showLogin && <SignUp setShowLogin={setShowLogin} />}
        <Navbar setShowLogin={setShowLogin} />
        <Routes>
          <Route exact path="/" element={<HomePage />} />
          <Route path="/Menu" element={<Menu category={category} setCategory={setCategory} setShowPopUp={setShowPopUp} addToCart={addToCart}/>} />
          {/* addToCart={addToCart} */}
          <Route path="/AboutUs" element={<AboutUsPage />} />
          <Route path="/Cart" element={<Cart selectedItems={selectedItems} selectedButtons={selectedButtons}/>} />
           {/* selectedItems={selectedItems} */}
          <Route path="/PlaceOrder" element={<PlaceOrder />} />
          <Route path="/Payment" element={<PaymentMethod />} />
          {showPayment && <PaymentMethod setShowPayment={setShowPayment} />}
          <Route path="/orders" element={<MyOrders />} />
        </Routes>
        <Footer />
        {showPopUp && <AddOn setShowPopUp={setShowPopUp}  addToCart={addToCart} handleButtonClick={handleButtonClick}/>}
        
        </RecommendationProvider>
        </StoreContextProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
